import range from 'lodash/range';

import {
  Select,
  Typography,
  Stack,
  tokens,
  colorOrToken,
} from '@cast/design-system';

import { TimeInput } from './TimeInput';
import { MonthState } from '../_types';
import { useInputs } from '../useInputs';

const allDays = range(1, 32).map(String);

export const MonthInput = () => {
  const { state, setState, isView } = useInputs<MonthState>();
  const noDaySelection = state.onDay.length === 0;

  return (
    <Stack gap={4}>
      <Stack gap={8} display="grid" gridTemplateColumns="1fr 1fr">
        <Select
          inputProps={{ label: 'On:' }}
          options={allDays}
          value={state.onDay}
          checkable
          multiple
          inputText={`${noDaySelection ? 'Select' : 'Selected'} days`}
          onChange={(value) =>
            setState((state) => {
              return { ...state, onDay: value };
            })
          }
          disabled={isView}
          testId="day-select"
          applySortingWhileSearching={false}
        />

        <TimeInput
          time={state.at}
          onTimeChange={(newTime) =>
            setState((state) => ({ ...state, at: newTime }))
          }
          label="At:"
          InputProps={{
            readOnly: isView || noDaySelection,
            testId: 'time-input',
          }}
          sx={{ width: '100%' }}
        />
      </Stack>
      {noDaySelection && (
        <Typography
          variant="P12R"
          color={colorOrToken('red.500', tokens.theme.fg.status.error)}
        >
          Day of month is required
        </Typography>
      )}
    </Stack>
  );
};
